var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 18.3327C3.09722 18.3327 2.89931 18.2528 2.73958 18.0931C2.57986 17.9334 2.5 17.7355 2.5 17.4993V13.3327C2.5 12.8743 2.66319 12.482 2.98958 12.1556C3.31597 11.8292 3.70833 11.666 4.16667 11.666V8.33268C4.16667 7.87435 4.32986 7.48199 4.65625 7.1556C4.98264 6.82921 5.375 6.66601 5.83333 6.66601H9.16667V5.45768C8.91667 5.29102 8.71528 5.08963 8.5625 4.85352C8.40972 4.6174 8.33333 4.33268 8.33333 3.99935C8.33333 3.79102 8.375 3.58615 8.45833 3.38477C8.54167 3.18338 8.66667 2.99935 8.83333 2.83268L10 1.66602L11.1667 2.83268C11.3333 2.99935 11.4583 3.18338 11.5417 3.38477C11.625 3.58615 11.6667 3.79102 11.6667 3.99935C11.6667 4.33268 11.5903 4.6174 11.4375 4.85352C11.2847 5.08963 11.0833 5.29102 10.8333 5.45768V6.66601H14.1667C14.625 6.66601 15.0174 6.82921 15.3438 7.1556C15.6701 7.48199 15.8333 7.87435 15.8333 8.33268V11.666C16.2917 11.666 16.684 11.8292 17.0104 12.1556C17.3368 12.482 17.5 12.8743 17.5 13.3327V17.4993C17.5 17.7355 17.4201 17.9334 17.2604 18.0931C17.1007 18.2528 16.9028 18.3327 16.6667 18.3327H3.33333ZM5.83333 11.666H14.1667V8.33268H5.83333V11.666ZM4.16667 16.666H15.8333V13.3327H4.16667V16.666Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCakeIcon);
export default __webpack_public_path__ + "static/media/cake-icon.9a00f7200094630ca33ff1162ea05ca6.svg";
export { ForwardRef as ReactComponent };